import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";

const TimesheetPieChart = ({ projectName, timesheetData }) => {
  // Calculate billable and non-billable hours
  const billableHours = useMemo(() => {
    let billable = 0;
    let nonBillable = 0;

    timesheetData.forEach((entry) => {
      const { billable: isBillable, duration } = entry;
      const [hours, minutes] = duration.split(":").map(Number);
      const totalHours = hours + minutes / 60;

      if (isBillable === 1) {
        billable += totalHours;
      } else {
        nonBillable += totalHours;
      }
    });

    return { billable, nonBillable };
  }, [timesheetData]);

  // Generate unique color based on the index
  const generateColor = (index) => {
    const baseColors = ["#3acce6", "#faad51"];
    if (index < baseColors.length) return baseColors[index];
  };

  // Prepare data for the Pie chart
  const chartData = [
    {
      name: "Billable",
      value: billableHours.billable,
      itemStyle: { color: generateColor(0) },
    },
    {
      name: "Non-Billable",
      value: billableHours.nonBillable,
      itemStyle: { color: generateColor(1) },
    },
  ];

  const option = {
    title: {
      left: "center",
      textStyle: {
        fontSize: 18,
        fontWeight: "bold",
      },
    },
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c} hours ({d}%)",
    },
    legend: {
      orient: "vertical",
      bottom: "10px",
      right: "right",
    },
    series: [
      {
        name: "Hours",
        type: "pie",
        radius: "80%",
        data: chartData,
        label: { show: false },
        labelLine: { show: false },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  return (
    <div className="project-status">
      <h2 className="pie-header">Billable vs Non-Billable Hours</h2>
      {chartData.some((item) => item.value > 0) ? (
        <ReactECharts
          className="pie-chart"
          option={option}
          style={{ height: "400px", top: "15px" }}
        />
      ) : (
        <div className="duration-image-container dashboard-image-extra">
          <img
            className="billable-image"
            src="/AppLayout/nonbillable-Billable.png"
            alt="No Data Available"
          />
          <p>Booked hours not available for this project</p>
        </div>
      )}
    </div>
  );
};

export default TimesheetPieChart;
